export default __webpack_public_path__ + "static/media/devimage.7b06cecb.png";